<template>
  <div class="role-list-div"
       style="height:100%">
    <Card style="min-height:100%">
      <Row>
        <Col :span="8">
        <Input search
               enter-button="搜索"
               size="large"
               @on-search="renderRolePageList"
               v-model="queryVO.roleName"></Input>
        </Col>
        <Col :span="3"
             :offset="13">
        <Button type="success"
                long
                icon="ios-add"
                size="large"
                @click="goAddRole">新增</Button>
        </Col>

      </Row>
      <br/>
      <Row>
        <Table border
               ref="tablesMain"
               :data="tableData"
               :columns="columns">
          <template slot-scope="{ row, index }"
                    slot="handle">
            <Button type="primary"
                    size="small"
                    @click="goEditRole(row)"
                    style="margin-left:5px;">编辑</Button>
            <Button type="primary"
                    size="small"
                    @click="goConfigUser(row)"
                    style="margin-left:5px;">配置用户</Button>
            <!-- <Button type="primary"
                    size="small"
                    @click="goConfigPerm(row)"
                    style="margin-left:5px;">配置权限</Button> -->
            <Button type="error"
                    size="small"
                    @click="goDeleteRole(row)"
                    style="margin-left:5px;">删除</Button>
          </template>
        </Table>
        <br/>
        <Page :total="total"
              show-total
              v-if="total!=0"
              :page-size="10"
              :current="queryVO.pageIndex+1"
              @on-change="changePageIndex" />
      </Row>
    </Card>
  </div>
</template>
<script>
import { queryRolePageList, deleteRole } from "@/api/user/role.js";
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  name: "RoleList",
  data () {
    return {
      queryVO: {
        roleName: "",
        pageIndex: 0
      },
      total: 0,
      roleStatusMap: new Map([[0, "禁用"], [1, "启用"]]),
      tableData: [],
      columns: [
        {
          title: "名称",
          key: "roleName",
          tooltip: true,
          align: "center"
        },
        {
          title: "状态",
          key: "statusName",
          tooltip: true,
          align: "center"
        },
        {
          title: "说明",
          key: "roleRemark",
          tooltip: true,
          align: "center"
        },
        {
          title: "操作",
          slot: "handle",
          tooltip: true,
          width: "300px",
          align: "center"
        }
      ]
    };
  },
  created () {
    this.renderRolePageList();
  },
  methods: {
    // ...mapMutations(["setRole"]),
        ...mapMutations('user', {
$_setRole: 'setRole',
   }),
    renderRolePageList () {
      queryRolePageList(this.queryVO).then(res => {
        this.total = res.data.total;
        this.tableData = res.data.data.map(element => {
          let resultObj = { ...element };
          resultObj.statusName = this.roleStatusMap.get(element.roleUsesMark);
          return resultObj;
        });
      });
    },
    goAddRole () {
      this.$router.push("roleAdd");
    },
    goDeleteRole (role) {
      this.$Modal.confirm({
        title: "确认框",
        content: "确定删除" + role.roleName + "?",
        onOk: () => {
          deleteRole(role.roleID).then(res => {
            this.renderRolePageList();
          });
        }
      });
    },
    goEditRole (role) {
      this.$_setRole(role);
      this.$router.push("roleEdit");
    },
    goConfigUser (role) {
      this.$_setRole(role);
      this.$router.push("roleConfigUser");
    },
    // goConfigPerm (role) {
    //   this.$_setRole(role);
    //   this.$router.push("roleConfigPerm");
    // },
    changePageIndex (current) {
      this.queryVO.pageIndex = current - 1;
      this.renderRolePageList();
    }
  }
};
</script>
